export default "__VITE_ASSET__c59c09a2__"